var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex rating-star mt-2"},[_vm._l((Math.floor(_vm.rating)),function(n,index){return _c('div',{key:index},[_vm._m(0,true)])}),_c('span',[_vm._v("("+_vm._s(_vm.rating)+")")])],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fas fa-star me-2"},[_c('span')])
}]

export { render, staticRenderFns }